export default {
  all: {
    teams: [],
    athletes: [],
  },
}
